export default {
  methods: {
    async render_line(data,type) {
      let xAxisData = data && data.length ? data.map(v=>{
        return type ? v.refDate + ' - ' + v.endRefDate : v.refDate
      }) : []
      let seriesData = data && data.length ? data.map(v=>v.visitNum) : []
      let option = {
        title: {},
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: 10,
          // right: '4%',
          right: 10,
          bottom: 30,
          top: 30,
          containLabel: true
        },
        xAxis: {
          data: xAxisData,
        },
        yAxis: {
          name: ''
        },
        dataZoom: {
          type: 'inside',
          start: 0,
          end: ((window.innerWidth == 1920 ? 12 : 10)/seriesData.length)*100
        },
        series: [
          {
            type: 'line',
            smooth: true,
            showSymbol: false,
            data: seriesData.length == 1 ? [...seriesData,0] : seriesData,
          },
        ]
      };
      let $instance = this.$echarts.init(this.$refs['lineChats']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
      });
    }
  }
}